var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7744 0L0 49.2384L10.352 65.7824L32.1856 52.2784V41.6384H49.2832L89.3152 16.8192L78.7744 0ZM92.0672 21.2736L59.1712 41.6992H96.016L102.349 37.8208L92.0672 21.2768V21.2736ZM105.158 42.16L96.7712 47.2768V56.8384H81.3504L59.952 70.1472H94.8576L114.848 57.7472L105.158 42.16V42.16ZM34.6432 56.8832L13.12 70.2624L23.3984 86.7264L32.272 81.232V70.1472H50.0896L71.488 56.8832H34.6432V56.8832ZM117.603 62.1568L96.8896 75.04V85.344H80.2048L38.6624 111.098L49.2224 128L128 78.7616L117.6 62.1536L117.603 62.1568ZM35.4464 85.344L26.1728 91.104L35.9328 106.701L70.3264 85.344H35.4464V85.344Z",
    className: "primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignerIcon);
export default __webpack_public_path__ + "static/media/signer_icon.feae47d0b65f2413ca670063eed3dd8b.svg";
export { ForwardRef as ReactComponent };